import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { blogVerisi } from '../data/blogVerisi'; 

function Blog() {
  const makaleler = blogVerisi || [];
  
  // SİHİRLİ SAYFALAMA (PAGINATION) MOTORU DOSTUM
  const [aktifSayfa, setAktifSayfa] = useState(1);
  const sayfadakiMakaleSayisi = 9; // Her sayfada en fazla 9 makale olacak

  // Hangi makalelerin gösterileceğini matematiksel olarak hesaplıyoruz
  const sonMakaleninIndexi = aktifSayfa * sayfadakiMakaleSayisi;
  const ilkMakaleninIndexi = sonMakaleninIndexi - sayfadakiMakaleSayisi;
  const gosterilenMakaleler = makaleler.slice(ilkMakaleninIndexi, sonMakaleninIndexi);

  // Toplam kaç sayfa olacağını buluyoruz
  const toplamSayfaSayisi = Math.ceil(makaleler.length / sayfadakiMakaleSayisi);

  // Sayfa değiştirme fonksiyonu
  const sayfaDegistir = (sayfaNumarasi) => {
    setAktifSayfa(sayfaNumarasi);
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Yeni sayfaya geçince en üste kaydır
  };

  return (
    <div className="blog-page-wide-wrapper">
      
      {/* İŞTE BLOG VİTRİNİNE ÖZEL VIP GOOGLE KİMLİĞİ */}
      <Helmet>
        <title>{aktifSayfa > 1 ? `Sektör Rehberi - Sayfa ${aktifSayfa} | Demir Grup` : `Sektör Rehberi & Makaleler | Demir Grup Güvenlik Sistemleri Ankara`}</title>
        <meta name="description" content="Ankara'da güvenlik kamera sistemleri, zayıf akım ve inşaat fileleri hakkında mühendislerimizden premium makaleler ve sektör rehberi." />
        <link rel="canonical" href={`https://www.ddemirgrup.com.tr/blog${aktifSayfa > 1 ? `?sayfa=${aktifSayfa}` : ''}`} />
        
        {/* Google'a 'Bu bir Blog sayfasıdır ve içindeki makaleler bunlardır' diyen akıllı JSON */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Blog",
            "name": "Demir Grup Sektör Rehberi",
            "description": "Güvenlik teknolojileri ve mühendislik ipuçları.",
            "url": "https://www.ddemirgrup.com.tr/blog",
            "publisher": {
              "@type": "Organization",
              "name": "Demir Grup",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.ddemirgrup.com.tr/logo.png"
              }
            },
            "blogPost": gosterilenMakaleler.map((makale) => ({
              "@type": "BlogPosting",
              "headline": makale.baslik,
              // SİHİRLİ KOD: Makale vitrin listesine de joker olarak Logomuzu verdik! Hata 0'a indi.
              "image": "https://www.ddemirgrup.com.tr/logo.png",
              "url": `https://www.ddemirgrup.com.tr/blog/${makale.id}`,
              "datePublished": "2026-03-10",
              "author": {
                "@type": "Organization",
                "name": "Demir Grup İnşaat & Güvenlik Sistemleri"
              }
            }))
          })}
        </script>
      </Helmet>

      {/* BAŞLIK ALANI: TURUNCU VURGULU VIP TASARIM */}
      <div className="blog-header-wide">
        <h1 className="blog-title-wide" style={{ color: '#ea580c', textShadow: '0 0 20px rgba(234, 88, 12, 0.3)' }}>
          Uzmanından Sektör Rehberi
        </h1>
        <p className="blog-desc-wide">
          Projelerinizi daha güvenli hale getirecek mühendislik ipuçları ve teknolojik yenilikler.
        </p>
      </div>

      <div className="blog-grid-wide">
        {gosterilenMakaleler.length > 0 ? (
          gosterilenMakaleler.map((makale) => (
            <div key={makale.id} className="blog-card-wide-typography">
              <div className="blog-card-wide-body">
                <span className="blog-date-wide">{makale.tarih}</span>
                <h3 className="blog-card-wide-title">{makale.baslik}</h3>
                <p className="blog-card-wide-summary">{makale.ozet}</p>
                <Link to={`/blog/${makale.id}`} className="card-btn-premium" style={{ textDecoration: 'none' }}>
                  Hemen Detayları Oku →
                </Link>
              </div>
            </div>
          ))
        ) : (
          <div className="blog-no-data" style={{color: 'white', gridColumn: '1 / -1', textAlign: 'center'}}>Makaleler yükleniyor...</div>
        )}
      </div>

      {/* SAYFALAMA (PAGINATION) LÜKS BUTONLARI */}
      {toplamSayfaSayisi > 1 && (
        <div className="pagination-container" style={{ marginTop: '60px' }}>
          <button 
            onClick={() => sayfaDegistir(aktifSayfa - 1)} 
            disabled={aktifSayfa === 1}
            className="page-btn nav-btn"
          >
            &#10094; Önceki
          </button>
          
          {Array.from({ length: toplamSayfaSayisi }, (_, index) => (
            <button
              key={index + 1}
              onClick={() => sayfaDegistir(index + 1)}
              className={`page-btn ${aktifSayfa === index + 1 ? 'active' : ''}`}
            >
              {index + 1}
            </button>
          ))}

          <button 
            onClick={() => sayfaDegistir(aktifSayfa + 1)} 
            disabled={aktifSayfa === toplamSayfaSayisi}
            className="page-btn nav-btn"
          >
            Sonraki &#10095;
          </button>
        </div>
      )}

    </div>
  );
}

export default Blog;